/**
 * Symbole für die Bausteine.
 *
 * Eine Kachel mit dem Wort „Zwei Spalten" sagt weniger als eine Zeichnung
 * zweier Spalten. Die Symbole zeigen den Aufbau des Bausteins — man erkennt
 * beim Überfliegen, was man bekommt, ohne zu lesen.
 *
 * Bewusst schlichte Strichzeichnungen in einer Farbe: Sie sollen die
 * Bauflächen-Vorschau nicht überstrahlen, und sie erben über `currentColor`
 * die Farbe der Kachel (grau, beim Überfahren blau).
 */

/**
 * @param {string} inhalt
 * @returns {string}
 */
const symbol = (inhalt) =>
  `<svg viewBox="0 0 48 34" fill="none" xmlns="http://www.w3.org/2000/svg"
        stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
        aria-hidden="true">${inhalt}</svg>`;

/** Ein gefülltes Rechteck als Platzhalter für eine Fläche. */
const flaeche = (x, y, b, h, deckung = '0.16') =>
  `<rect x="${x}" y="${y}" width="${b}" height="${h}" rx="1.5"
         fill="currentColor" fill-opacity="${deckung}" stroke="none" />`;

/** Eine Textzeile. */
const zeile = (x, y, b, staerke = '1.6') =>
  `<line x1="${x}" y1="${y}" x2="${x + b}" y2="${y}" stroke-width="${staerke}" />`;

/** @type {Record<string, string>} */
export const SYMBOLE = {
  'kanzlei-kopf': symbol(`
    ${flaeche(6, 8, 13, 9, '0.28')}
    ${zeile(6, 24, 20, '1.4')}
  `),

  'kanzlei-anrede': symbol(`
    ${zeile(6, 14, 28)}
    ${zeile(6, 21, 14, '1.4')}
  `),

  'kanzlei-titel': symbol(`
    ${zeile(6, 13, 30, '3.4')}
    ${zeile(6, 22, 20, '1.4')}
  `),

  'kanzlei-absatz': symbol(`
    ${zeile(6, 11, 36, '1.4')}
    ${zeile(6, 17, 36, '1.4')}
    ${zeile(6, 23, 22, '1.4')}
  `),

  'kanzlei-hinweis': symbol(`
    ${flaeche(5, 7, 38, 20, '0.14')}
    <line x1="8" y1="7" x2="8" y2="27" stroke-width="2.6" />
    ${zeile(13, 14, 24, '1.4')}
    ${zeile(13, 20, 16, '1.4')}
  `),

  'kanzlei-schaltflaeche': symbol(`
    <rect x="6" y="10" width="24" height="14" rx="3"
          fill="currentColor" fill-opacity="0.18" />
    ${zeile(11, 17, 14, '1.8')}
    ${zeile(35, 17, 7, '1.4')}
  `),

  'kanzlei-zwei-spalten': symbol(`
    ${flaeche(5, 8, 17, 18)}
    ${flaeche(26, 8, 17, 18)}
  `),

  'kanzlei-bild': symbol(`
    <rect x="5" y="7" width="38" height="21" rx="2.5"
          fill="currentColor" fill-opacity="0.08" />
    <circle cx="14" cy="14" r="2.2" fill="currentColor" stroke="none" fill-opacity="0.6" />
    <path d="M8 26l9-8 6 5 5-4 7 7" stroke-width="1.6" />
  `),

  'kanzlei-trenner': symbol(`
    ${zeile(6, 17, 36, '1.8')}
  `),

  'kanzlei-fuss': symbol(`
    ${flaeche(5, 12, 38, 15, '0.14')}
    ${zeile(10, 18, 20, '1.4')}
    ${zeile(10, 23, 13, '1.4')}
  `),
};

/**
 * Symbol für einen Baustein, mit unauffälligem Ersatz.
 *
 * @param {string} id
 * @returns {string}
 */
export function symbolFuer(id) {
  return SYMBOLE[id] ?? symbol(`${flaeche(6, 9, 36, 16, '0.12')}`);
}
